export default __webpack_public_path__ + "static/media/dresser001.f8058565.jpeg";